import { styled } from "@mui/material";

import { PieChart as UnstyledPieChart } from "../pie-chart";

export const CenterContent = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  maxWidth: theme.spacing(16.5),
}));

export const TooltipDatasetName = styled("span")({
  fontWeight: 700,
});

export const PieChart = styled(UnstyledPieChart)(({ theme }) => ({
  height: theme.spacing(29),
  width: theme.spacing(29),
})) as typeof UnstyledPieChart;
